/**
 * バリデーションルール
 * 共通部分は、ここに書くこと
 */
export default {
  // ユーザーID
  userId: 'email|max:255',

  // パスワード
  passwordRule: 'regex:^[A-Za-z0-9]+$|min:8|max:16',

  // 日付(YYYY-MM-DD)
  requiredDateRule: 'required|date_format:yyyy-MM-dd',

  // 画像
  imageRule: 'ext:jpeg,jpg,png|size:1024',
}
